const loans = {
  status: {
    PENDING_STATUS_NUMBER: 1,
    REVIEWING_STATUS_NUMBER: 5,
    APPROVED_STATUS_NUMBER: 7,
    DENIED_STATUS_NUMBER: 9,
  },
};

export { loans };
